<template>
  <section class="cost-section payable now">
    <table class="totals">
      <tbody>
        <tr>
          <td>
            <translate tag="strong"> Payable now </translate>
          </td>
          <td class="amount">
            <pu-price :price="priceTotal" :display-original-price="true" />
          </td>
        </tr>
        <tr class="info">
          <td colspan="2">
            <p>
              <template v-if="isRefundableAfterToday">
                <translate :tt="{ campsiteName }">
                  {campsiteName} will bill you the total amount now.
                </translate>
                <br />
                <translate :tt="{ commission: depositPercent }">
                  This includes a {commission, puNumber, style:percent}
                  non-refundable deposit.
                </translate>
                <translate :tt="{ refundUntilDate }">
                  Balance refunds available until {refundUntilDate, puDate,
                  full}
                </translate>
              </template>
              <template v-else>
                <translate :tt="{ campsiteName }">
                  {campsiteName} will bill you the total amount now
                  (non-refundable).
                </translate>
              </template>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { MoneyType as Money } from '~/utility/money'

@Component
class BookingPaymentImmediate extends Vue {
  @Prop()
  priceTotal: Money

  @Prop()
  campsiteName: string

  @Prop({ required: true })
  depositPercent: number

  @Prop()
  refundUntilDate: string

  get isRefundableAfterToday() {
    const today = new Date()
    const refundableDate = new Date(this.refundUntilDate)
    return refundableDate > today
  }
}

export default toNative(BookingPaymentImmediate)
</script>
